import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IRootUiStore } from '../RootUiStore';
import IMobxProviderContext from '../interfaces/IMobxProviderContext';

const useUiStore = (): IRootUiStore => useContext<IMobxProviderContext>(MobXProviderContext as any).rootUiStore;

export default useUiStore;
